import { Checkbox, mergeStyleSets, MessageBar, Pivot, PivotItem, Stack } from '@fluentui/react';
import { observer } from 'mobx-react';
import { InfoTooltipLabel } from '../../../controls/InfoTooltipLabel';
import EntityMultiColumnSelector from '../EntityMultiColumnSelector';
import { ProvisionProfileEditorState } from '../../provision-profiles/ProvisionProfileEditor';
import NewPeoplePicker, { PeoplePickerIdFormat } from '../../../controls/NewPeoplePicker';
import TokenPathTagPicker, { TokenPathTagPickerState } from '../../../controls/TokenPathTagPicker';

const contentStyles = mergeStyleSets({
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
	urlContainer: {
		marginTop: '5px',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
});

function EntityTypeDialogFavouritesTab({
	state
}: {
	state: ProvisionProfileEditorState;
}) {

	return (
		<section className={contentStyles.section}>

			<Pivot>
				<PivotItem headerText='People fields'>

					<Stack horizontal>


						<InfoTooltipLabel label='Auto favorite people fields' title={`When people are added to the selected people fields, the ${state.entityTypePluralName} will be favorited for them automatically. For example, an 'Assigned To' field.`}>
							<EntityMultiColumnSelector state={state.autoFavouritePeopleFields}/>
						</InfoTooltipLabel>
						
						<InfoTooltipLabel label='Always auto-favourite' title={`These people will always be added to the favourites.`}>
							<NewPeoplePicker format={PeoplePickerIdFormat.UPN} siteUrl={state.listUrl} config={state.userConfig} initialPeople={state.FavouritesPeople} updatePeople={(people) => state.setFavouritesPeople(people)} />
						</InfoTooltipLabel>

					</Stack>
				</PivotItem>

				<PivotItem headerText='OneDrive'>

					<InfoTooltipLabel label='OneDrive synchronization' title={`When a ${state.entityTypePluralName} item is favorited, it can be automatically synchronized to OneDrive.`}>
						<Checkbox
							label={'Synchronize user favorites to OneDrive'}

							checked={state.EnableOneDriveSync}
							onChange={(e, checked) => { state.setOneDriveSync(checked?.valueOf() ?? false); } }
						/>
					</InfoTooltipLabel>
					{!!state.EnableOneDriveSync && (
						<div className={contentStyles.urlContainer}>
							
							<InfoTooltipLabel 
								label={`Specify the OneDrive folder path for synchronization of ${state.entityTypePluralName}. `}
								title='Construct your OneDrive from these tokens and the path will be generated dynamically based on your metadata.'>
							
								<TokenPathTagPicker
									state={new TokenPathTagPickerState(
										(path) => { state.setOneDriveSyncPath(path); },
										'',
										undefined,
										state.OneDriveSyncPath,
										state.tokens ?? []
									)}
								/>
							</InfoTooltipLabel>
							

							{state.OneDriveSyncPath && (
								<MessageBar>
									Favorited {state.entityTypePluralName} will be synchronized to user desktops under <strong>{state.OneDriveSyncPath}</strong>.
								</MessageBar>
							)}
						</div>
					)}

			
				</PivotItem>
			</Pivot>
		</section>
	);
}

export default observer(EntityTypeDialogFavouritesTab);
